<template>
  <div>
    <video
      id="webcam"
      autoplay
      playsinline
      width="600"
      height="480"
      :style="sizeobject"
    ></video>
    <canvas id="canvas" class="d-none"></canvas>
  </div>
</template>
<script>
import Webcam from "webcam-easy";
export default {
  name: "webcamEasy",
  components: {},
  data() {
    return {
      webcamElement: null,
      canvasElement: null,
      sizeobject: {
        width: "0px",
        height: "0px",
      },
      videoheight: 0,
    };
  },
  computed: {},
  methods: {
    calcheight() {
      this.webcam.snap();
      console.log(this.webcam);
      if (this.webcamElement == null) return 0;
      let width= this.webcam._webcamElement.scrollWidth;
      let height= this.webcam._webcamElement.scrollHeight;
      console.log(width, height);
      if (this.videoheight < height) {
        let tmp = width;
        width = (tmp * this.videoheight) / height;
        height = this.videoheight;
        console.log(width, height);
        this.sizeobject.width = width + "px";
        this.sizeobject.height = height + "px";
      } else {
        this.sizeobject.width = "100%";
        this.sizeobject.height = "auto";
      }
    },
    flip() {
      this.webcam.flip();
      this.webcam.start();
    },
    snap() {
      return this.webcam.snap();
    },
    start() {
      this.webcam.start();
    },
    stop() {
      this.webcam.stop();
    },
  },
  async mounted() {
    this.videoheight = window.innerHeight / 2;
    this.webcamElement = document.getElementById("webcam");
    this.canvasElement = document.getElementById("canvas");
    this.webcam = new Webcam(this.webcamElement, "user", this.canvasElement, null);
    this.webcam.start();
    this.calcheight();
  },
};
</script> 

<style lang="scss" scoped></style>